<template>
    <div>
        <v-container fluid :style="{ 'min-height': '800px' }">
            <v-container class="contain-width">

                <v-row>
                    <v-col
                            cols="12"
                            md="8"
                            offset-md="2"
                    >
                        <h1 class="mt-6 mb-6">{{ $t('headings.Verify email address') }}</h1>
                        <v-card
                                class="mx-auto form-card"
                                outlined
                        >

                            <v-card-text class="text--primary">

                                <p class="headline">{{ $t("Please verify your email address") }}</p>
                                <p v-if="verificationSent">{{ $t("An email has been sent to {email}", {email: usersEmail}) }}</p>
                                <p>{{ $t("Please check your inbox for the email we sent from {support}", {support: supportEmail}) }}</p>
                                <p>{{ $t("You will need to confirm your email address before you can access all website features, and activate tags") }}.</p>
                                <p>{{ $t("Please make sure you are logged in on the same device and browser, that the email link opens in") }}.</p>

                            </v-card-text>

                            <v-card-actions>
                                <v-btn
                                        class="ma-2"
                                        :loading="loading"
                                        :disabled="loading"
                                        rounded
                                        elevation="0"
                                        color="primary"
                                        @click="resendVerification"
                                >
                                    <span v-if="sent">{{ $t("Please check your email") }}</span>
                                    <span v-else>{{ $t("Resend verification email") }}</span>
                                    <template v-slot:loader>
                                    <span class="custom-loader">
                                      <v-icon light>cached</v-icon>
                                    </span>
                                    </template>
                                    <v-icon v-if="sent">mdi mdi-check</v-icon>
                                </v-btn>
                            </v-card-actions>

                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <Footer />
    </div>
</template>

<script>

    import axios from 'axios';

    import Footer from './Footer.vue'
    import { store } from '../store';
    import { mapState, mapActions } from 'vuex'
    import {i18n} from "../i18n";

    export default {
        name: "Verify",
        components: {
            'Footer': Footer
        },
        metaInfo() {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('Verify'),
            htmlAttrs: {
              lang: i18n.locale
            }
          }
        },
        data () {
            return {
                email_verification_sent_at: null,
                loader: '',
                loading: false,
                sent: false
            }
        },
        mounted () {

            window.scrollTo(0,0);
            let user = this.user;
            if (user && user.email_verification_sent_at) {
                this.email_verification_sent_at = user.email_verification_sent_at

            }
        },
        computed: {
            ...mapState({
                user: state => state.account.user,
                brand: state => state.brand,
                brandName: state => state.brandName
            }),
            getBackground() {
              if (this.brand === 'neotag') {
                return require('@/assets/neotag-background.jpg')
              }
              else {
                return require('@/assets/neotag-background.jpg')
              }
            },
            supportEmail() {
              if (this.brand === 'neotag') {
                return 'info@neotag.es'
              }
              else {
                return 'support@findmykit.com'
              }
            },
            verificationSent() {
                let user = this.user;
                if (user && user.email_verification_sent_at) {
                    return true

                }
                else {
                    return false
                }
            },
            usersEmail() {
                let user = this.user;
                if (user && user.email) {
                    return user.email
                }
                else {
                    return ''
                }
            }
        },
        methods: {
            ...mapActions('account', ['updateVerificationSent']),
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            resendVerification() {
                this.loading = true
                this.loader = 'loading'
                this.sent = false

                let apiClient = axios.create({
                    baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
                    withCredentials: true,
                });

                return apiClient.get('/sanctum/csrf-cookie').then(() => {
                    return apiClient
                        .post(process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST + '/email/verification-notification')
                        .then(response => {
                            this.loading = false
                            this.sent = true
                            if (response.status === 202) {
                                // let user = this.user;
                                // user.email_verification_sent_at = response.data.email_verification_sent_at
                                this.updateVerificationSent(response.data.email_verification_sent_at)
                                //localStorage.setItem('user', JSON.stringify(user));
                            }
                        })
                        .catch(error => {
                            console.log(error)
                            this.loading = false
                            store.dispatch('alert/error', error.response.data.error, {root: true});
                        })
                })
            }
        }
    }
</script>

<style scoped>
    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }
    @-moz-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-webkit-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-o-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
</style>
